<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: null
    }
  },
  created() {
    this.getUserInfo();
    document.title = "华肤荟";
  },
  methods: {
    getUserInfo() {
      this.$axios.get('/api/api/web/Customer/GetMyInfo').then(res => {
        console.log(res.Data)
        this.userInfo = res.Data;
        let uid = this.userInfo ? this.userInfo.BaseInfo.Id : '';
        let nickName = this.userInfo.BaseInfo.RealName;
        location.href = `https://v.e-way.cc/?id=65d0a3863c294b3bbe0d199f32153e4d&nickName=${encodeURIComponent(nickName)}&uid=${uid}`;
      })
    }
  }
}
</script>